var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-cbt-modal-component" }, [
    _c("div", { staticClass: "room-cbt-modal flex flex-col" }, [
      _c(
        "div",
        { staticClass: "room-cbt-header" },
        [
          _c("h6", [_vm._v("출제 이력")]),
          _c("GrmCloseBtn", { on: { click: _vm.onClose } }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "min-h-0 flex-1 overflow-hidden flex flex-col" },
        [
          _c(
            "div",
            {
              staticClass:
                "room-cbt-list-wrapper min-h-0 flex-1 overflow-y-auto",
            },
            [_c("RoomCBTLogList")],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }